import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'
import { IResourceFieldProjector } from '~/client/src/shared/resources/projection/types'
import { IHierarchyAccessors } from '~/client/src/shared/utils/hierarchyAccessors'
import { UNASSIGNED_FILTER_VALUE } from '~/client/src/shared/utils/ZoneLevelLocationConstants'

import { IGroupNode } from './groupPath'

// Resolve the group paths a record belongs to for a grouping field. A plain
// field yields single-node paths; a Hierarchy Property yields the value's
// ancestor chain (root -> leaf), so groups nest along the hierarchy.
export const getResourceGroupPaths = (
  record: IResourceRecord,
  fieldKey: string,
  hierarchy: IHierarchyAccessors | undefined,
  fieldProjector: IResourceFieldProjector,
  unassignedLabel: string,
): IGroupNode[][] => {
  const entries = fieldProjector.resolve(record, fieldKey).groupEntries

  if (!entries.length) {
    return [[{ value: UNASSIGNED_FILTER_VALUE, label: unassignedLabel }]]
  }

  return entries.map(entry => {
    if (hierarchy) {
      const ancestors = hierarchy.getAncestorChain(entry.id)
      if (ancestors.length) {
        return ancestors.map(node => ({ value: node.value, label: node.label }))
      }
    }
    return [{ value: entry.id, label: entry.label }]
  })
}
